/**
 * Get static source url
 * @param {*} path pathname
 * @returns static source url
 */
export const getStaticUrl = (path) => {
  const fullPath = path.replace(/(^\/+)(.*)/, '$2');
  return `${window.mainConfig.staticResourceHost}${fullPath}`;
};
